// extracted by mini-css-extract-plugin
module.exports = {"Card":"style_Card__18iUY","Marck":"style_Marck__DjPdw","Wrapper":"style_Wrapper__3CdVP","Content":"style_Content__dqB-c","Text":"style_Text__wy_GR","Result":"style_Result__1gQFU"};